<template>
  <MainLayout class="container mx-auto">
    <SceneTitle class="mt-10">
      단어설명
      <template slot="description">
        궁금한 단어를 눌러주세요
      </template>
    </SceneTitle>

    <div class="p-4 mt-4 text-center sm:px-32 sm:mt-10">
      <div class="flex flex-wrap justify-center p-4 bg-white border rounded-lg sm:py-32">
        <a
          v-for="(item, index) of items"
          :key="index"
          class="p-2 m-2 text-lg font-bold border-2 border-black sm:p-4 sm:m-4 sm:text-2xl item rounded-2xl cursor-pointer"
          @click="view(index)"
        >
          {{ item.name }}
        </a>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import appConfig from '@src/app.config'
import MainLayout from '@layouts/main-layout.vue'
import { FAQS } from '@state/modules/faq'
import SceneTitle from '@components/game/scene-title.vue'

export default {
  page: {
    title: appConfig.title,
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { SceneTitle, MainLayout },
  data() {
    return {
      items: [
        {
          name: '#키오스크',
          content:
            '공공장소에 설치된 안내기기 또는 무인주문기. 건물안내, 시설, 행사, 박람회, 식당 등에서 정보를 제공해주거나 주문을 받는 용도로 사용되고 있습니다.',
        },
        { name: '#터치', content: '손 또는 손가락으로 ‘만지다’, ‘건드리다’라는 뜻의 영어표현입니다.' },
        { name: '#ATM(에이 티 엠)', content: '현금자동입출금기. 은행의 입금 및 출금 등을 할 수 있는 기계입니다.' },
        { name: '#미션', content: '목적달성 임무.' },
        { name: '#스페셜', content: '보통의 것과는 특별히 다른 것을 의미하는 ‘특수한’, ‘특별한’ 뜻의 영어표현입니다.' },
        { name: '#버거', content: '햄버거, 샌드위치의 일종입니다.' },
        { name: '#프리미엄', content: '‘아주 높은’, ‘고급의’ 라는 뜻의 영어표현입니다.' },
        {
          name: '#와퍼',
          content:
            '1957년 출시된 버거킹의 대표 메뉴. 일반 햄버거의 평균 두께인 3.81츠 5.08cm의 크기를 내세우고 있습니다.',
        },
        { name: '#주니어', content: '‘청소년’, ‘나이어린’ 이란 뜻의 영어표현입니다.' },
        { name: '#디저트', content: '‘후식’이란 뜻의 영어표현입니다.' },
        {
          name: '#세트',
          content:
            '두개 이상의 상품으로 된 구성. 햄버거 세트의 겨우 햄버거, 감자튀김, 콜라 이렇게 3개정도로 구성되어 있습니다.',
        },
        { name: '#라지세트', content: '크기가 크거나 또는 양이 많은 햄버거, 감자튀김, 콜라의 구성' },
        { name: '#프렌치 프라이', content: '기름에 튀긴 감자' },
        { name: '#포테이토', content: '‘감자’라는 뜻의 영어표현입니다.' },
        { name: '#드링크', content: '‘음료’라는 뜻의 영어표현입니다.' },
      ],
    }
  },
  methods: {
    view(index) {
      this.$store.commit(FAQS.NAMESPACE(FAQS.SET_FAQ), this.items[index])
      this.$router.push({ path: '/faq/view' })
    },
  },
}
</script>

<style scoped>
.item {
  background-color: var(--color-bg);
}
</style>
